import { Injectable } from '@angular/core';
import { EDropdownTypes, ERefTypes } from '../enums';

export interface BadgeItem {
  type: string;
  value: string;
}
export interface Saperator {
  name: string;
  type?: string;
}
export interface SubChildren {
  state: string;
  name: string;
  type?: string;
}
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  child?: SubChildren[];
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  saperator?: Saperator[];
  children?: ChildrenItems[];
}

const MENUITEMS = [
  // {
  //   state: 'starter',
  //   name: 'Starter Page',
  //   type: 'link',
  //   icon: 'content_copy'
  // },
  // {
  //   state: 'material',
  //   name: 'Material Ui',
  //   type: 'sub',
  //   icon: 'bubble_chart',
  //   badge: [{ type: 'red', value: '17' }],
  //   children: [
  //     { state: 'badge', name: 'Badge', type: 'link' },
  //     { state: 'button', name: 'Buttons', type: 'link' },
  //     { state: 'cards', name: 'Cards', type: 'link' },
  //     { state: 'grid', name: 'Grid List', type: 'link' },
  //     { state: 'lists', name: 'Lists', type: 'link' },
  //     { state: 'menu', name: 'Menu', type: 'link' },
  //     { state: 'tabs', name: 'Tabs', type: 'link' },
  //     { state: 'stepper', name: 'Stepper', type: 'link' },
  //     { state: 'ripples', name: 'Ripples', type: 'link' },
  //     { state: 'expansion', name: 'Expansion Panel', type: 'link' },
  //     { state: 'chips', name: 'Chips', type: 'link' },
  //     { state: 'toolbar', name: 'Toolbar', type: 'link' },
  //     { state: 'progress-snipper', name: 'Progress snipper', type: 'link' },
  //     { state: 'progress', name: 'Progress Bar', type: 'link' },
  //     { state: 'dialog', name: 'Dialog', type: 'link' },
  //     { state: 'tooltip', name: 'Tooltip', type: 'link' },
  //     { state: 'snackbar', name: 'Snackbar', type: 'link' },
  //     { state: 'slider', name: 'Slider', type: 'link' },
  //     { state: 'slide-toggle', name: 'Slide Toggle', type: 'link' }
  //   ]
  // },

  {
    state: 'components',
    name: 'SideBar.Components',
    type: 'link',
    icon: 'dns'
  },
  {
    state: 'models',
    name: 'SideBar.Models',
    type: 'link',
    icon: 'account_tree'
  },
  {
    state: 'assets',
    name: 'SideBar.Assets',
    type: 'link',
    icon: 'account_balance'
  },
  {
    state: 'perspectives',
    name: 'SideBar.Perspectives',
    type: 'link',
    icon: 'remove_red_eye'
  },
  // {
  //   state: 'alarms',
  //   name: 'Alarms',
  //   type: 'link',
  //   icon: 'notifications_active'
  // },
  {
    state: 'datasource',
    name: 'SideBar.DataSource',
    type: 'sub',
    icon: 'sensor_window',
    children: [
      { state: 'intellija', name: 'SideBar.IntellijaBroker', type: 'link', icon: 'format_italic' }, //format_bold // supervised_user_circle
      { state: 'sparkplug', name: 'SideBar.MQTT', type: 'link', icon: 'power' },
      { state: '', name: 'SideBar.OPC-UA', type: 'link', icon: 'local_parking' },
    ]
  },
  {
    state: 'eu',
    name: 'SideBar.UOM',
    type: 'link',
    icon: 'tune'
  },
  {
    state: 'reports',
    name: 'SideBar.Reports',
    type: 'link',
    icon: 'library_books'
  },
  {
    state: 'user-management',
    name: 'SideBar.UserManagement',
    type: 'sub',
    icon: 'person',
    children: [
      { state: 'users', name: 'SideBar.Users', type: 'link', icon: 'people' },
      { state: 'usergroups', name: 'SideBar.UserGroups', type: 'link', icon: 'groups' },
      { state: 'roles', name: 'SideBar.Roles', type: 'link', icon: 'manage_accounts' },
      // {state: 'features', name: 'Features', type: 'link', icon: 'assignment'},
    ]
  },
  {
    state: 'settings',
    name: 'SideBar.Settings',
    type: 'sub',
    icon: 'settings',
    children: [
      { state: 'dropdowns', name: 'Dropdowns', type: 'link', icon: 'arrow_drop_down_circle' }
    ]
  }
];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}